export default {
  page: {
    title: "Reader management",
    subtitle:
      "Register POS readers, pair SumUp terminals, and link them to devices",
    tabReaders: "Readers",
    tabPresets: "Reader presets",
    newReader: "New reader",
    searchPlaceholder: "Search by serial number, brand, model…",
    showMockReaders: "Show mock terminals",
    filterPairing: "Pairing",
    filterDeviceStatus: "Device status",
    filterStatusAll: "All",
    filterDeviceOnline: "Online",
    filterDeviceUnavailable: "Unavailable",
    filterDeviceUnknown: "Not checked",
    colBrand: "Brand",
    colSerial: "Serial number",
    colRegion: "Region",
    colStatus: "Status",
    colDevice: "Assigned device",
    colActions: "Actions",
    emptySearch: "No readers match your search.",
    emptyDefault: "No readers registered yet.",
    deleteTitle: "Delete reader",
    deleteConfirm:
      'Delete reader "{{serial}}" from inventory? This cannot be undone.',
    deleteConfirmPaired:
      'Delete reader "{{serial}}"? It will be unpaired from SumUp and removed from inventory. This cannot be undone.',
    readerDeleted: "Reader deleted",
    readerRenamed: "Reader serial number updated",
    readerCreated: "Reader registered",
    readerPaired: "Reader paired with SumUp",
    readerUnpaired: "Reader unpaired from SumUp",
    statusCreated: "Created",
    statusNotPaired: "Not paired",
    statusPaired: "Paired",
    deviceOnline: "Online",
    deviceOffline: "Offline",
    deviceBattery: "Battery: {{level}}%",
    deviceState: {
      IDLE: "Idle",
      SELECTING_TIP: "Selecting tip",
      UPDATING_FIRMWARE: "Updating firmware",
      WAITING_FOR_CARD: "Waiting for card",
      WAITING_FOR_PIN: "Waiting for PIN",
      WAITING_FOR_SIGNATURE: "Waiting for signature",
      UNKNOWN: "Unknown state",
    },
    deviceLastChecked: "Last checked: {{time}}",
    deviceLastActivity: "Last activity: {{time}}",
    refreshAllDeviceStatuses: "Refresh device statuses",
    deviceStatusesRefreshed: "Device statuses refreshed",
    deviceStatusesRefreshedPartial:
      "Refreshed {{updated}} device status(es); {{failed}} failed",
    deviceStatusesRefreshFailed:
      "Failed to refresh {{failed}} device status(es)",
    deviceStatusesNothingToRefresh: "No paired SumUp readers to refresh",
    regionLocked: "Locked",
    regionLockedHint:
      "Region locked after a successful payment and cannot be changed",
    openAssignedDevice: "Open device {{name}}",
    pairAction: "Pair with SumUp",
    unpairAction: "Unpair from SumUp",
    unlinkFromDeviceAction: "Unlink from device",
    unlinkFromDeviceConfirm:
      'Unlink reader "{{serial}}" from device "{{device}}"? SumUp pairing is kept; payments stay disabled until you link it again.',
    readerUnlinkedFromDevice: "Reader unlinked from device",
    changeRegionAction: "Change region",
    regionUpdated: "Reader region updated",
    unpairConfirm:
      'Unpair reader "{{serial}}" from SumUp? It will stay in inventory.',
  },
  renameModal: {
    title: "Rename reader",
    help: "Update the serial number for reader {{serial}}.",
    serialLabel: "Serial number",
    serialPlaceholder: "Enter device serial number",
    serialRequired: "Serial number is required",
  },
  createModal: {
    title: "Register reader",
    serialLabel: "Serial number",
    serialPlaceholder: "Enter device serial number",
    serialRequired: "Serial number is required",
    regionLabel: "Region",
    chooseRegion: "Select region…",
    regionRequired: "Select a region",
    presetSelectorTitle: "Choose a reader preset",
    presetsEmpty:
      "No presets found. Create one from the Reader presets tab first.",
    presetCardSpecs: "{{model}} • {{provider}} • {{flow}}",
    presetRequired: "Please select a reader preset",
    submit: "Register reader",
  },
  pairModal: {
    title: "Pair SumUp reader",
    help: "Enter the pairing code shown on terminal {{serial}}.",
    codeLabel: "Pairing code",
    codePlaceholder: "8–9 characters",
    codeInvalid: "Enter the 8–9 character pairing code from the SumUp device.",
    submit: "Pair reader",
  },
  changeRegionModal: {
    title: "Change reader region",
    help: "Select the payment region for reader {{serial}}.",
    regionLabel: "Region",
    regionRequired: "Region is required",
    unpairWarning:
      "This reader is paired with SumUp. Changing region will delete it from SumUp and clear the local pairing.",
    unpairConfirm:
      'Change region for "{{serial}}"? The SumUp pairing will be removed automatically.',
    submit: "Save region",
  },
  presets: {
    brandPlaceholder: "Brand (e.g. SumUp)",
    modelPlaceholder: "Model (e.g. Solo)",
    providerPlaceholder: "Provider (e.g. SUMUP)",
    flowPlaceholder: "Flow (e.g. CLOUD_POS)",
    add: "Add preset",
    save: "Save changes",
    updated: "Preset updated",
    created: "Preset created",
    deleted: "Preset deleted",
    deleteConfirm: 'Delete preset "{{name}}"?',
    deleteTitle: "Delete preset",
    editTitle: "Edit preset",
    colBrand: "Brand",
    colModel: "Model",
    colProvider: "Provider",
    colFlow: "Flow",
    colActions: "Actions",
    empty: "No presets yet.",
    validationRequired: "Fill in all preset fields.",
  },
} as const;
